module.exports = __webpack_public_path__ + "static/images/exclamation.jwQ1pwm.svg";